export default __webpack_public_path__ + "static/media/element_22.4879d78a.jpg";